import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ApproveAccessRequestMutationVariables = Types.Exact<{
  input: Types.ApproveAccessRequestInput;
}>;


export type ApproveAccessRequestMutation = { __typename?: 'Mutation', approveAccessRequest?: { __typename?: 'AccessRequestPayload', accessRequest?: { __typename?: 'AccessRequest', id?: string | null } | null } | null };


export const ApproveAccessRequest = /*#__PURE__*/ gql`
    mutation ApproveAccessRequest($input: ApproveAccessRequestInput!) {
  approveAccessRequest(input: $input) {
    accessRequest {
      id
    }
  }
}
    ` as unknown as DocumentNode<ApproveAccessRequestMutation, ApproveAccessRequestMutationVariables>;

          

          export const useApproveAccessRequestMutation = (options?:MutationHookOptions<ApproveAccessRequestMutation, ApproveAccessRequestMutationVariables>) => useMutation(ApproveAccessRequest, options);
          

          export type ApproveAccessRequestMutationOptions = MutationHookOptions<ApproveAccessRequestMutation, ApproveAccessRequestMutationVariables>;

          

          export type ApproveAccessRequestMutationResult = ReturnType<typeof useApproveAccessRequestMutation>[1];

          
